<ion-content #content *ngIf="dataServ.rData">
  <ion-header>
    <ion-toolbar>
      <ion-back-button
        color="white"
        slot="start"
        defaultHref="/home"
        text=""
        icon="chevron-back"
      ></ion-back-button>

      <ion-title>
        <ion-text color="white" class="ion-text-center">
          <h1>{{ dataServ.rData.name | caption | translate }}</h1>
        </ion-text>
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-grid class="content-grid about-content">
    <ion-row class="w-reservation">
      <swiper #slider mode="ios" pager="ios" [config]="config" class="no-btn">
        <ng-container *ngIf="dataServ.rData && didInit">
          <ng-container *ngFor="let img of dataServ.rData.slider_images">
            <ng-container>
              <ng-template swiperSlide>
                <video
                  class="free-video"
                  [poster]="img"
                  loop
                  autoplay
                  [muted]="true"
                  [controls]="false"
                  playsinline
                >
                  <source [src]="img" type="video/mp4" />
                  <img class="free-img" [src]="img" #divideImg />
                </video>
              </ng-template>
            </ng-container>
          </ng-container>
        </ng-container>
      </swiper>

      <ion-col size="12">
        <div class="safe-area"></div>
      </ion-col>
    </ion-row>

    <ion-row>
      <!-- <ion-col size="12" class="playbutton">
        <ion-icon name="play" color="primary"></ion-icon>
      </ion-col> -->
    </ion-row>

    <ion-row class="bottom-row">
      <ion-col size="12" (click)="scrollDetail()">
        <ion-text color="white">
          <h1>{{ "Details" | translate }}</h1>
          <ion-icon name="chevron-down"></ion-icon>
        </ion-text>
      </ion-col>

      <ion-col size="12">
        <ion-button
          *ngIf="dataServ.rData.online_reservation_url | caption"
          label="hotel-reservation"
          [disabled]="processing"
          color="primary"
          (click)="resButton()"
        >
          <div class="square" appEqualWidthHeight equalWith="height">
            <ion-icon name="calendar-outline" color="primary"></ion-icon>
          </div>
          {{ "Reservation" | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid class="description-grid" *ngIf="dataServ.rData">
    <ion-row
      class="buttons"
      *ngIf="
        dataServ.rData.contact_phone ||
        dataServ.rData.lat_lng ||
        dataServ.rData.web_site_url
      "
    >
      <ion-col size="2" *ngIf="dataServ.rData.contact_phone">
        <ion-button
          label="hotel-call"
          appEqualWidthHeight
          equalWith="width"
          href="tel:{{ dataServ.rData.contact_phone }}"
        >
          <ion-icon slot="icon-only" name="call-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="2" *ngIf="dataServ.rData.contact_email">
        <ion-button
          label="hotel-email"
          appEqualWidthHeight
          equalWith="width"
          href="mailto:{{ dataServ.rData.contact_email }}"
        >
          <ion-icon slot="icon-only" name="mail-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <!-- <ion-col size="2">
        <ion-button label="hotel-survey" appEqualWidthHeight equalWith="width"
          (click)="modalServ.survey(dataServ.rData, 'rich')">
          <ion-icon slot="icon-only" name="star-outline"></ion-icon>
        </ion-button>
      </ion-col> -->

      <ion-col size="2" *ngIf="dataServ.rData.sm_instagram_url">
        <ion-button
          label="hotel-instagram"
          appEqualWidthHeight
          equalWith="width"
          target="_blank"
          href="{{ dataServ.rData.sm_instagram_url }}"
        >
          <ion-icon slot="icon-only" name="logo-instagram"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="2" *ngIf="dataServ.rData.sm_facebook_url">
        <ion-button
          label="hotel-facebook"
          appEqualWidthHeight
          equalWith="width"
          target="_blank"
          href="{{ dataServ.rData.sm_facebook_url }}"
        >
          <ion-icon slot="icon-only" name="logo-facebook"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="2" *ngIf="dataServ.rData.sm_youtube_url">
        <ion-button
          label="hotel-youtube"
          appEqualWidthHeight
          equalWith="width"
          target="_blank"
          href="{{ dataServ.rData.sm_youtube_url }}"
        >
          <ion-icon slot="icon-only" name="logo-youtube"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="2" *ngIf="dataServ.rData.sm_twitter_url">
        <ion-button
          label="hotel-twitter"
          appEqualWidthHeight
          equalWith="width"
          target="_blank"
          href="{{ dataServ.rData.sm_twitter_url }}"
        >
          <ion-icon slot="icon-only" name="logo-twitter"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="2" *ngIf="dataServ.rData.sm_vkontakte_url">
        <ion-button
          label="hotel-vk"
          appEqualWidthHeight
          equalWith="width"
          target="_blank"
          href="{{ dataServ.rData.sm_vkontakte_url }}"
        >
          <ion-icon slot="icon-only" name="logo-vk"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="2" *ngIf="dataServ.rData.lat_lng">
        <ion-button
          label="hotel-location"
          appEqualWidthHeight
          equalWith="width"
          href="https://www.google.com/maps/dir/?api=1&destination={{
            dataServ.rData.lat_lng
          }}"
          target="_blank"
        >
          <ion-icon slot="icon-only" name="location-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="2" *ngIf="dataServ.rData.web_site_url | caption">
        <ion-button
          label="hotel-website"
          appEqualWidthHeight
          equalWith="width"
          (click)="modalServ.openLink(dataServ.rData.web_site_url)"
        >
          <ion-icon slot="icon-only" name="earth-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="2" *ngIf="dataServ.rData.virtual_tour_url | caption">
        <ion-button
          label="hotel-virtual-tour"
          appEqualWidthHeight
          equalWith="width"
          (click)="modalServ.openLink(dataServ.rData.virtual_tour_url)"
        >
          <ion-icon slot="icon-only" name="image-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="2" *ngIf="dataServ.rData.trip_advisor_link">
        <ion-button
          label="hotel-trip_advisor_link"
          appEqualWidthHeight
          equalWith="width"
          target="_blank"
          href="{{ dataServ.rData.trip_advisor_link }}"
        >
          <img
            src="assets/icon/tripadvasor.png"
            alt=""
            class="responsive-icon"
          />
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row class="description">
      <ng-container *ngIf="dataServ.rData.hotel_information | caption">
        <ion-col size="12">
          <ion-text color="primary">
            <h1>{{ "Details" | translate }}:</h1>
          </ion-text>
        </ion-col>

        <ion-col size="12">
          <ion-text color="dark">
            <p
              [innerHtml]="
                dataServ.rData.hotel_information | caption | translate
              "
            ></p>
          </ion-text>
        </ion-col>
      </ng-container>

      <ng-container *ngIf="dataServ.rData.address">
        <ion-col size="12">
          <ion-text color="primary">
            <h1>{{ "Address" | translate }}:</h1>
          </ion-text>
        </ion-col>

        <ion-col size="12">
          <ion-text color="dark">
            <p [innerHtml]="dataServ.rData.address"></p>
          </ion-text>
        </ion-col>
      </ng-container>

      <ng-container *ngIf="dataServ.rData.virtual_tour_url">
        <ion-col size="12">
          <ion-text color="primary">
            <h1>{{ "Virtual Tour" | translate }}:</h1>
          </ion-text>
        </ion-col>

        <ion-col size="12">
          <ion-text color="dark">
            <p
              [innerHtml]="dataServ.rData.virtual_tour_url"
              (click)="modalServ.openLink(dataServ.rData.virtual_tour_url)"
            ></p>
          </ion-text>
        </ion-col>
      </ng-container>

      <ng-container
        *ngIf="
          dataServ.rData.contact_email ||
          dataServ.rData.contact_phone ||
          dataServ.rData.whatsapp_no
        "
      >
        <ion-col size="12">
          <ion-text color="primary">
            <h1>{{ "Contact Us" | translate }}:</h1>
          </ion-text>
        </ion-col>

        <ion-col size="12">
          <ion-text color="dark">
            <h5 class="contact-us">
              <ng-container *ngIf="dataServ.rData?.contact_phone">
                {{ "Phone" | translate }}: &nbsp;
                <a href="tel:{{ dataServ.rData.contact_phone }}"
                  ><b>{{ dataServ.rData.contact_phone }}</b> </a
                ><br />
              </ng-container>
              <ng-container *ngIf="dataServ.rData?.contact_email">
                {{ "Email" | translate }}: &nbsp;
                <a href="mailto:{{ dataServ.rData.contact_email }}"
                  ><b>{{ dataServ.rData.contact_email }}</b></a
                ><br />
              </ng-container>

              <span *ngIf="dataServ.rData.whatsapp_no"
                >{{ "Whatsapp" | translate }}: &nbsp;
                <a
                  target="_blank"
                  href="https://wa.me/{{ dataServ.rData.whatsapp_no }}"
                  ><b>{{ dataServ.rData.whatsapp_no }}</b></a
                ></span
              >
            </h5>
          </ion-text>
        </ion-col>
      </ng-container>

      <!-- <div class="watermark">
        <img src="assets/img/logo-outline.svg" alt="Relax Resort">
      </div> -->
    </ion-row>

    <ion-row
      class="gallery"
      *ngIf="
        dataServ.rData.slider_images && dataServ.rData.slider_images.length > 1
      "
    >
      <ion-col size="2.7">
        <div class="square"></div>
        <ion-text color="dark">
          <h5>{{ "Gallery" | translate }}</h5>
        </ion-text>
      </ion-col>
      <ion-col
        size="7"
        *ngFor="
          let img of dataServ.rData.slider_images;
          let first = first;
          let sIndex = index
        "
        [class]="first ? 'first' : ''"
      >
        <ion-img
          (click)="fullPageSlider.initialSlide = sIndex; fullImage = true"
          [src]="img"
        ></ion-img>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12" *ngIf="dataServ.rData.lat_lng">
        <!-- <div id="map" appEqualWidthHeight equalWith="width"></div> -->
        <google-map
          appEqualWidthHeight
          equalWith="width"
          [zoom]="18"
          [center]="center"
        >
          <map-marker
            *ngFor="let location of locations"
            [position]="{
              lat: +location.location[0],
              lng: +location.location[1]
            }"
            [label]="location.item.name | caption"
            (mapClick)="open(location.item)"
            [clickable]="true"
          ></map-marker>
          <map-marker [position]="marker[0]"></map-marker>
        </google-map>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-row class="version-info">
    <ion-col size="12">
      <ion-text
        *ngIf="oneSignalId && oneSignalId.length > 6"
        color="primary"
        class="version-text"
        (click)="copyToClipboard(oneSignalId)"
      >
        <small> {{ oneSignalId }} </small>
        <ion-icon name="copy-outline" size="small"></ion-icon>
      </ion-text>
    </ion-col>
  </ion-row>
  <ion-row class="version-info">
    <ion-col size="12">
      <ion-text
        *ngIf="version && version.trim() !== ''"
        color="primary"
        class="version-text"
        (click)="copyToClipboard(version)"
      >
        <small> {{ version }} </small>
        <ion-icon name="copy-outline" size="small"></ion-icon>
      </ion-text>
    </ion-col>
  </ion-row>
</ion-content>

<div class="full-img" *ngIf="fullImage">
  <div class="bg-overlay" (click)="fullImage = false"></div>
  <ion-icon name="close" color="white" (click)="fullImage = false"></ion-icon>
  <ion-slides mode="ios" pager="ios" zoom [options]="fullPageSlider">
    <ion-slide *ngFor="let img of dataServ.rData.slider_images">
      <img [src]="img" />
    </ion-slide>
  </ion-slides>
</div>
